import { render, staticRenderFns } from "./SelectFarmType.vue?vue&type=template&id=58379c94&scoped=true"
import script from "./SelectFarmType.vue?vue&type=script&lang=js"
export * from "./SelectFarmType.vue?vue&type=script&lang=js"
import style0 from "./SelectFarmType.vue?vue&type=style&index=0&id=58379c94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58379c94",
  null
  
)

export default component.exports